// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"938a161a","453":"b1f095a9","455":"7efea47d","977":"d9103fe4"}[chunkId] + ".chunk.js";
};